import type from './action-type';
import { combineReducers } from 'redux';

const reducer = {};

const page = {
  size: 8,
  num: 1
};
reducer.page = (state = page, action = {}) => {
  const { payload } = action;

  switch (action.type) {
    case type.SET_PAGE_SIZE:
      return { ...state, size: payload };
    case type.SET_PAGE_NUM:
      return { ...state, num: payload };
    case type.INIT:
      return page;
    default:
      return state;
  }
};

reducer.list = (state = null, action = {}) => {
  const { payload } = action;

  switch (action.type) {
    case type.INIT:
      return null;
    case type.SET_LIST:
      return payload;
    default:
      return state;
  }
};

reducer.order = (state = null, action = {}) => {
  const { payload } = action;

  switch (action.type) {
    case type.INIT:
      return null;
    case type.SET_ORDER:
      return payload;
    default:
      return state;
  }
};

reducer.sortField = (state = null, action = {}) => {
  const { payload } = action;

  switch (action.type) {
    case type.INIT:
      return null;
    case type.SET_SORT_FIELD:
      return payload;
    default:
      return state;
  }
};

export default combineReducers({ ...reducer });
